/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMachineLearning = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M20 2v5h2v2h-2v5h-4v2h1a5 5 0 0 1 4.995 4.783L22 21v1H2v-1a5 5 0 0 1 5-5h1v-2H4V9H2V7h2V2zm-3 16H7c-1.302 0-2.41.83-2.825 1.988L4.17 20h15.659l-.076-.193a3.002 3.002 0 0 0-2.577-1.802zm-3-4h-4v2h4zm4-10H6v8h12zm-8 2v4H8V6zm6 0v4h-2V6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMachineLearning as MachineLearning };
